var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 66,
    viewBox: "0 0 68 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 33V54C66 59.5228 61.5228 64 56 64H50M41 64H12C6.47715 64 2 59.5228 2 54V40.5M2 28V35",
    stroke: "#FFD467",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C2 10.4772 6.47715 6 12 6H56C61.5228 6 66 10.4772 66 16V24H2V16Z",
    fill: "#F1924A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C21.1046 0 22 0.89543 22 2V12C22 13.1046 21.1046 14 20 14C18.8954 14 18 13.1046 18 12V2C18 0.89543 18.8954 0 20 0Z",
    fill: "#00B5B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 0C49.1046 0 50 0.89543 50 2V12C50 13.1046 49.1046 14 48 14C46.8954 14 46 13.1046 46 12V2C46 0.89543 46.8954 0 48 0Z",
    fill: "#00B5B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4142 32.5858C26.6332 31.8047 25.3668 31.8047 24.5858 32.5858C23.8047 33.3668 23.8047 34.6332 24.5858 35.4142L31.1716 42L24.5858 48.5858C23.8047 49.3668 23.8047 50.6332 24.5858 51.4142C25.3668 52.1953 26.6332 52.1953 27.4142 51.4142L34 44.8284L40.5858 51.4142C41.3668 52.1953 42.6332 52.1953 43.4142 51.4142C44.1953 50.6332 44.1953 49.3668 43.4142 48.5858L36.8284 42L43.4142 35.4142C44.1953 34.6332 44.1953 33.3668 43.4142 32.5858C42.6332 31.8047 41.3668 31.8047 40.5858 32.5858L34 39.1716L27.4142 32.5858Z",
    fill: "#00B5B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.c4a057ed699cc0197847bd7736625219.svg";
export { ForwardRef as ReactComponent };